import { TAGBrand } from '@shared-components/types';

export interface IOnPageSchedulingDetails {
	coords?: {
		latitude?: number;
		longitude?: number;
	};
	brand: TAGBrand;
}
/*
 * Get the scheduling system for the facility based on the brand and coordinates. (for WellNow brands )
 * @param {IOnPageSchedulingDetails} params - The parameters for getting the scheduling system.
 * @returns {Promise<string | null>} - The scheduling system or null if not found.
 */
export async function getOnPageSchedulingDetails({ coords: _coords, brand: _brand }: IOnPageSchedulingDetails) {
	return 'InHouse';
}
